<template>
  <v-btn
    v-if="!company.active_subscription"
    :to="{ name: 'subscription' }"
    color="primary"
  >
    {{ $t('texts.buySubscription') }}
  </v-btn>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapCompanyProfileState } = createNamespacedHelpers('company/profile');

export default {
  name: 'CallToAction',
  computed: {
    ...mapCompanyProfileState([
      'company',
    ]),
  },
};
</script>
